import {
    getRaydiumTransferPositionTransaction,
    getRaydiumUpdateLiquidityTransaction,
    TxnManageRaydiumLiquidityParams,
    TxnTransferRaydiumPositionParams
} from "@bridgesplit/abf-sdk";

import { useAbfFetches } from "../reducers";
import { AbfTransactionDetails, AbfGeneratorResult } from "../types";
import { useAbfGenerateTransaction, wrapAsAbfGeneratorResult } from "./common";
import { useCreateSimulationPromise } from "./simulation";

export function useRaydiumLiquidityTransaction(): AbfTransactionDetails<TxnManageRaydiumLiquidityParams> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions, resetLoanLuts } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: TxnManageRaydiumLiquidityParams): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({
                generateFunction: getRaydiumUpdateLiquidityTransaction,
                identifier: "Update liquidity",
                params: args
            }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
            resetLoanLuts();
        }
    };

    return { getTransactionsWithParams, sendOptions, description: "Update liquidity" };
}

export function useRaydiumUpdatePositionTransaction(): AbfTransactionDetails<TxnTransferRaydiumPositionParams> {
    const generate = useAbfGenerateTransaction();
    const { resetLoanApi, resetClmmPositions, resetLoanLuts } = useAbfFetches();
    const createSimulationPromise = useCreateSimulationPromise({ skipSimulate: true });

    function getTransactionsWithParams(args: TxnTransferRaydiumPositionParams): AbfGeneratorResult {
        return wrapAsAbfGeneratorResult(
            generate({
                generateFunction: getRaydiumTransferPositionTransaction,
                identifier: "Update position",
                params: args
            }),
            createSimulationPromise,
            { order: "sequential" }
        );
    }

    const sendOptions = {
        refetch: () => {
            resetLoanApi();
            resetClmmPositions();
            resetLoanLuts();
        }
    };

    return { getTransactionsWithParams, sendOptions, description: "Update position" };
}
